export const eventLabels = {
    DONE_CONTACT_BUTTON_CLICK: 'DONE_CONTACT_BUTTON_CLICK',
    MATCH_CARD_CLICK: 'MATCH_CARD_CLICK',
    GLOBAL_TRANSFER_OPEN: 'GLOBAL_TRANSFER_OPEN',
    GLOBAL_TRANSFER_INITIATE: 'GLOBAL_TRANSFER_INITIATE',
    GLOBAL_TRANSFER_CLOSE: 'GLOBAL_TRANSFER_CLOSE',
    INLINE_TRANSFER_OPEN: 'INLINE_TRANSFER_OPEN',
    INLINE_TRANSFER_INITIATE: 'INLINE_TRANSFER_INITIATE',
    TRANSFER_CLOSE: 'TRANSFER_CLOSE',
    CONTACT_ACTIONS_MODAL_OPEN_FOR_TRANSFER: 'CONTACT_ACTIONS_MODAL_OPEN_FOR_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_EMAIL_TRANSFER: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_EMAIL_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_CONFIRM_TRANSFER: 'CUSTOMER_SUPPORT_ACTION_CONFIRM_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_CHAT_TRANSFER_FORM: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_CHAT_TRANSFER_FORM',
    CUSTOMER_SUPPORT_ACTION_SEND_PHONE_LINK: 'CUSTOMER_SUPPORT_ACTION_SEND_PHONE_LINK',
    THREE_WAY_CALL_CANCEL: 'THREE_WAY_CALL_CANCEL',
    THREE_WAY_CALL_LEAVE: 'THREE_WAY_CALL_LEAVE',
    THREE_WAY_CALL_MERGE: 'THREE_WAY_CALL_MERGE',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_TRANSFER_ESCALATION: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_TRANSFER_ESCALATION',
    WORKFLOW_INGRESS_CLICK: 'WORKFLOW_INGRESS_CLICK',
    WORKFLOW_CONTINUE_CLICK: 'WORKFLOW_CONTINUE_CLICK',
    WORKFLOW_INTERVENTION_CLICK: 'WORKFLOW_INTERVENTION_CLICK',
    WORKFLOW_SUBMIT_CLICK: 'WORKFLOW_SUBMIT_CLICK',
    WORKFLOW_CLOSE_CLICK: 'WORKFLOW_CLOSE_CLICK',
    SOLVE_CARD_OPEN_PRIMARY_VIEW: 'SOLVE_CARD_OPEN_PRIMARY_VIEW',
    SOLVE_CARD_OPEN_ACTION_VIEW: 'SOLVE_CARD_OPEN_ACTION_VIEW',
    // We should remove WORKFLOW_STEP_INITIALIZED: https://issues.amazon.com/issues/caracara-46528
    WORKFLOW_STEP_INITIALIZED: 'WORKFLOW_STEP_INITIALIZED',
    WORKFLOW_STEP_INITIALIZING: 'WORKFLOW_STEP_INITIALIZING',
    WORKFLOW_STEP_READY: 'WORKFLOW_STEP_READY',
    // Resource menu
    RESOURCE_MENU_POP_OVER_OPEN: 'RESOURCE_MENU_POP_OVER_OPEN',
    RESOURCE_MENU_POP_OVER_READY: 'RESOURCE_MENU_POP_OVER_READY'
};
/**
 * Constants to use when a value we want to use for a structured event is invalid.
 * For example, if we expect a string, but get a JSX element, we can use
 * INVALID_MSG.CANNOT_CONVERT_TO_STRING.
 */
export const INVALID_MSG = {
    INVALID: 'invalid',
    CANNOT_CONVERT_TO_STRING: 'invalid_cannot_convert_value_to_string',
    MISSING: 'invalid_missing',
    INVALID_SUBLEVEL: 'invalid_sublevel',
    INVALID_LOCATION: 'invalid_location',
};
/**
 * Constant that identifies when a Location provider did not provide a location
 * (either a location sublevel, or the full location has to be provided).
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 */
export const OMITTED_LOCATION = 'omitted_location';
/**
 * Constant that identifies when no base location was ever set in the Location
 * React Context hierarchy; at some point, a Location Provider should provide
 * a full location for children providers to build off of.
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 */
export const UNSPECIFIED_LOCATION = 'ac3/unspecified_location';
/**
 * Constant that replaces invalid locations. Example, 'testLocation' will be replaced
 * because camel case is expected.
 *
 * Examples
 * - `testLocation.[someIdentifier]` :: fails because camel case is expected for the sublevel (not in brackets)
 * - `test_location.[someIdentifier%%]` :: fails because identifier (in brackets) can only be alphanumeric with _ and -.
 * Replace non-alphanumeric characters with x
 * - `test_location.[]` :: fails because an identifier is needed
 * - `test_location.[someIdentifier.2nd_Id]` :: passes because multiple identifiers are allowed
 * - `test_location` :: passes because an identifier is not needed
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 */
export const INVALID_LOCATION = INVALID_MSG.INVALID_LOCATION;
/**
 * Regular Expression that is the source of truth for if a sublevel is correctly
 * formatted or not.
 *
 * Examples:
 * - test_location
 * - test_location.[someIdentifier]
 * - test_location.[someIdentifier.2ndId]
 * - test_location.[some_identifier.second_identifier]
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 */
export const SUB_LEVEL_REGEX = /^[a-z0-9_]+(\.\[[a-z0-9A-Z_-]+(\.[a-z0-9A-Z_-]+)*\])?$/;
//# sourceMappingURL=constants.js.map